









































































import Vue from 'vue'
import ModalSelectStockLibraryDesign from '@/common/components/StockLibrary/ModalSelectStockLibraryDesign.vue'

import {
  ProductState,
  StockLibraryDesign
} from '@/product/types'

import {
  DesignImageModalItem
} from '@/common/types'

export default Vue.extend({
  components: { ModalSelectStockLibraryDesign },
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data(): {
    showModalSelectStockLibraryDesign: boolean,
  } {
    return {
      showModalSelectStockLibraryDesign: false
    }
  },
  computed: {
    storeState(): ProductState {
      return this.$store.state
    },
    stockLibraryImg(): string | undefined {
      return this.storeState.stockLibraryDesign.imageUrl
    },
    stockLibUuid(): string {
      return this.storeState.stockLibraryDesign.uuid || ''
    }
  },
  methods: {
    toggleShowModalSelectStockLibraryDesign() {
      this.showModalSelectStockLibraryDesign = !this.showModalSelectStockLibraryDesign
    },
    onUpdateStockLibraryDesign(payload: { design: DesignImageModalItem }) {
      const data: StockLibraryDesign = {
        uuid: payload.design.uuid,
        imageUrl: payload.design.imageUrl || '',
        userDesignVersionUuid: payload.design.nonTransparentVersion?.uuid
      }
      this.$store.commit('setStockLibraryDesign', data)
      this.toggleShowModalSelectStockLibraryDesign()
    },
    clearSelectedStockLibraryDesign() {
      this.$store.commit('setStockLibraryDesign', {
        uuid: undefined,
        imageUrl: undefined,
        userDesignVersionUuid: undefined
      })
      this.$emit('removeStockLibraryData')
    }
  }
})
